module.exports = __webpack_public_path__ + "static/img/kai.f8d37e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kai.png
// module id = 6b0w
// module chunks = 1